module.exports = __webpack_public_path__ + "img/闲适.0830dc23.webp";